

// Swap page hero banner background image on mobile
// get the background image of the page-hero-banner using vanilla javascript
var desktopBanner = document.querySelector('.page-hero-banner');
if (desktopBanner) {
  var desktopUrl = desktopBanner.style.backgroundImage;
  // do something with desktopUrl
}

// get the data-mobile-src attribute of the page-hero-banner using vanilla javascript
var mobileBanner = document.querySelector('.page-hero-banner');
if (mobileBanner) {
  var mobileUrl = mobileBanner.getAttribute('data-mobile-background-image');
  // do something with mobileUrl
}

 var swapHeroBanner = function() {
    if (window.innerWidth < 768 && mobileUrl) {
        // if the window is less than 768px wide, swap the page-hero-banner background image to the mobileUrl using vanilla javascript
        document.querySelector('.page-hero-banner').style.backgroundImage = "url("+mobileUrl+")";
    } else
    {
      if (desktopUrl) {
        
        // if the window is wider than 768px, swap the page-hero-banner background image to the desktopUrl using vanilla javascript
        document.querySelector('.page-hero-banner').style.backgroundImage = "url("+desktopUrl+")";
      }
    }
}
// trigger the function on load
swapHeroBanner();

// trigger the function on resize using vanilla javascript
window.addEventListener('resize', swapHeroBanner);


// Swap page hero banner video on mobile

// get the source of the video.page-hero-banner-vid in vanilla javascript
var desktopUrl = document.querySelector('video.page-hero-banner-vid');
if (desktopUrl) {
  desktopUrl = desktopUrl.getAttribute('src');
}

// get the data-mobile-src attribute of the video.page-hero-banner-vid using vanilla javascript
var mobileUrl = document.querySelector('video.page-hero-banner-vid');
if (mobileUrl) {
  mobileUrl = mobileUrl.getAttribute('data-mobile-src');
}

// using vanilla javascript when the browser is resized or loaded, swap the video.page-hero-banner-vid source
var swapVideo = function() {
  var video = document.querySelector('video.page-hero-banner-vid');
  if (video && desktopUrl && mobileUrl) {
    if (window.innerWidth < 768) {
      // if the window is less than 768px wide, swap the video.page-hero-banner-vid source to the mobileUrl using vanilla javascript
      video.setAttribute('src', mobileUrl);
    } else {
      // if the window is wider than 768px, swap the video.page-hero-banner-vid source to the desktopUrl using vanilla javascript
      video.setAttribute('src', desktopUrl);
    }
  }
}
// trigger the function on load
swapVideo();

// trigger the function on resize using vanilla javascript
// window.addEventListener('resize', swapVideo);

$(window).on( 'load resize', function(){

  var maxHeight = 0;
$("div.card__information").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});

$("div.card__information").height(maxHeight);
});
